import React from 'react'
import { makeApiUrl } from '../helpers/makeApiUrl'
import { authHeader } from '../helpers/authHeader'
import { requestOption } from '../helpers/requestOption'
import { handleResponse } from '../helpers/handleResponse'
import { lStorage, lStorageKeys } from '../helpers/lStorage'
import { langService } from '../services/langService'
import { toArray } from '../helpers/objectLiteralToArray'
import { ROUTES_BY_ID } from '../constants/routes'
import { Link } from './Link'
import { _t } from '../i18n/lang'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class HeadMenu extends React.Component {
  constructor (props) {
    super(props) // w propsach mamy type = typ menu potencjalnie mozemy tego użyć do innych rzeczy
    this.state = {
      loading: false,
      isError: false,
      menu: (SSR_DATA && SSR_DATA.HeadMenu) ? SSR_DATA.HeadMenu : {}
    }
    this.handleOnClick = this.handleOnClick.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  componentDidMount () {
    this.loadData()
  }

  static async fetchData (data) {
    return {
      introduction_and_contact: {
        label: _t('MM_INTRODUCTION_AND_CONTACT'),
        link: 'introduction-and-contact',
      },
      modern_reporting: {
        label: _t('MM_MODERN_REPORTING'),
        menu: {
          customers: {
            label: _t('MM_CUSTOMERS'),
            link: 'customers'
          },
          current_orders: {
            label: _t('MM_CURRENT_ORDERS'),
            link: 'current-orders'
          },
          orders: {
            label: _t('MM_ORDERS'),
            link: 'orders'
          },
        }
      },

      surface_commercial_partner: {
        label: _t('MM_SURFACE_COMMERCIAL_PARTNER'),
        link: 'surface-commercial-partner',
      },
      surface_products: {
        label: _t('MM_SURFACE_PRODUCTS'),
        link: 'surface-products',
      },
      promotions_news_events: {
        label: _t('MM_PROMOS_NEWS_EVENTS'),
        link: 'promotions-news-events',
      },
      useful_materials: {
        label: _t('MM_USEFUL_METERIALS'),
        link: 'useful-materials',
      },
    }
  }

  loadData () {
    // zaczynamy ładować
    if (Object.keys(this.state.menu).length > 0) return
    this.setState({ loading: true })

    const cacheKey 	= lStorageKeys.HEAD_MENU_PREFIX + this.props.type + '_' + langService.get()
    // const cache 		= JSON.parse(lStorage.get(cacheKey))
    const cache 		= false;

    let isAdmin = false;
    const { privileges } = this.props.user

    if  (privileges && privileges.isAdmin) {
      isAdmin = privileges.isAdmin
    }

    if (cache) {
      this.setState({ loading: false, menu: cache })
    } else {
		    try {
		        HeadMenu.fetchData({ type: this.props.type }).then(jsonData => {
              lStorage.set(cacheKey, JSON.stringify(jsonData))
              if (!isAdmin) {
                delete jsonData.modern_reporting
              }

              this.setState({ loading: false, menu: jsonData })
			    })
		    } catch (ex) {
          this.setState({ isError: true })
		    }
	    }
  }

  /**
     * parsuje string z url pod katem bledu, gdzie '-' wystaepuje zamiast '/' po nazwie strefy, a przed numerem strefy
     */
  parseUrl (url) {
	    if (typeof url === 'undefined') {
	        return '#'
    }
	    const index = url.indexOf('-')
	    if ((index + 1) > url.length - 1) {
	        return url
    }
	    const n = url.charAt(index + 1)

	    if (n >= '0' && n <= '9') {
      return url.substring(0, index) + '/' + url.substring(index + 1)
    }
	    return url
  }

  generateMenuItem (menu_item, index, depth) {
    let item_class_name
	    if (depth === 0) {
      item_class_name = 'nav-item navbar-dropdown-item'
    } else {
	        item_class_name = 'nav-item submenu-dropdown-item'
    }
	    if (!menu_item.menu) {
	        let to = ''
	        if (menu_item.link) {
        to = '/' + this.parseUrl(menu_item.link)
      } else if (menu_item.id) {
        to = ROUTES_BY_ID[menu_item.id].path
        const re = /\/:.*\?/
        to = to.replace(re, '')
      }

	        if (depth === 0) {
        return <li
          onClick={this.handleOnClick}
          onMouseLeave={this.handleMouseLeave}
          onMouseEnter={this.handleMouseEnter}
          key={index}
          className={item_class_name}
               >
          <Link style={{ display: 'inline' }} to={to}>{menu_item.label}</Link>
               </li>
      } else {
        return <li
          onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
          onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}
               >
          <Link to={to}>{menu_item.label}</Link>
        </li>
      }
    } else if (menu_item.menu) {
      return this.generateSubmenu(menu_item, index, depth, item_class_name)
	    } else {

    }
  }

  generateSubmenu (menu_item, index, depth, item_class_name) {
    let result = []
    const that = this
    if (menu_item.menu) {
      toArray(menu_item.menu).forEach((element, index) => {
        result.push(that.generateMenuItem(element, index, depth + 1))
      })
    } else {
      result = <li />
    }
    let elem_style
    if (depth == 0) {
      // styles for first dropdown
      elem_style = {
        fontFamily: "'Rubik', sans-serif",
        fontWeight: 500,
        textAlign: 'left',
        marginLeft: -1 + 'em',
        paddingLeft: 0,
        minWidth: 15 + 'em',
        lineHeight: 2.67,
        borderTop: 'solid #33323a 11px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 8px 5px 20px -5px'
      }
    } else {
      // styles for futher 'dropright' menus
      elem_style = {
        fontWeight: 400,
        textAlign: 'left',
        marginLeft: 17 + 'em',
        marginTop: -3.15 + 'em',
        paddingLeft: 0,
        lineHeight: 1.33,
        borderTop: 'none',
        boxShadow: '10px 15px 40px 0 rgba(140, 138, 155, 0.2)',
        padding: '1rem .5rem',
        position: 'absolute',
        zIndex: '-1'
      }
    }
    let span = ''
    if (depth == 0) {
      span = <span style={{ position: 'relative', zIndex: '999' }}>{menu_item.label}</span>
    } else {
      span = <span>{menu_item.label}</span>
    }
    if (menu_item.link) {
      return <li
        onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
        onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}
             >
        <Link to={'/' + this.parseUrl(menu_item.link)}>{menu_item.label}</Link>
        <ul style={elem_style} className='dropdown-sublist'>{result}
        </ul>
             </li>
    } else {
      return <li
        onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
        onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}
             >{span}
        <ul style={elem_style} className='dropdown-sublist'>{result}
        </ul>
             </li>
    }
  }

  generateMenu (menu) {
    const that = this; const items = []
    Object.keys(menu).map((name, index) => { items.push(that.generateMenuItem(menu[name], index, 0)) })
    return items
  }

  handleOnClick (event) {
    document.querySelectorAll('li.item-hoovered').forEach((element) => {
      element.classList.remove('item-hoovered')
    })
  }

  handleMouseEnter (event) {
	    event.currentTarget.classList.add('item-hoovered')
  }

  handleMouseLeave (event) {
    event.currentTarget.classList.remove('item-hoovered')
  }

  render () {
    const { menu, loading } = this.state
    // jesli nie mamy jeszcze danych
    if (!menu || loading) return ''
    // let menuHtml = this.generateMenu(menu, []);
    const menuHtml = this.generateMenu(menu)
    return menuHtml
  }
}

const mapStateToProps = (state) => {
  return { user: state.user }
}

export default connect(mapStateToProps)(HeadMenu)
